import Vue from 'vue'
import Meta from 'vue-meta';
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';

import Search from '@/views/Search.vue';
Vue.component('Search', Search)
import Screening from '@/views/Screening.vue';
Vue.component('Screening', Screening)
import Nodata from '@/views/Nodata.vue';
Vue.component('Nodata', Nodata)

// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

// import axios from 'axios'
// Vue.prototype.$axios = axios
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function (data) {
    let src = ''
    for (let item in data) {
      src += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
    }
    return src
}]

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  if (to.meta.metaInfo){
      store.commit("CAHNGE_META_INFO", to.meta.metaInfo)
    }
  next()
});
Vue.use(Meta).use(VueAreaLinkage)
new Vue({
  router,
  store,
	metaInfo(){
		return {
			title: this.$store.state.metaInfo.title,
			meta: [
				{
					name: "keywords",
					content: this.$store.state.metaInfo.keywords
				}, {
					name: "description",
					content: this.$store.state.metaInfo.description
				}
			]
		}
	},
  render: h => h(App)
}).$mount('#app')
